/**
 * Custom type labels per document type.
 */
export const DOCUMENT_TYPE_LABEL = {
  UserDealer: 'User',
  FormPack: 'Form-Pack',
  FormTemplate: 'Form',
  WidgetConfig: 'Buttons',
};

export const DIFF_KIND = {
  NEW: 'N',
  EDIT: 'E',
  DELETE: 'D',
  ARRAY: 'A',
};

export const OPERATION = {
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
};

/**
 * Exclude keys from diff to make it less verbose
 */
export const DIFF_EXCLUDED_KEYS = ['id', 'dealer_id', 'dealerId'];
